module.exports = __webpack_public_path__ + "img/IMG-20200714-WA0007.86b65306.jpg";